import { render, staticRenderFns } from "./shipping-queue.vue?vue&type=template&id=72af3013&scoped=true&"
import script from "./js/shipping-queue.js?vue&type=script&lang=js&"
export * from "./js/shipping-queue.js?vue&type=script&lang=js&"
import style0 from "./shipping-queue.vue?vue&type=style&index=0&id=72af3013&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72af3013",
  null
  
)

export default component.exports